import {
  getBranchOffices,
  getDepartments,
  getJobTypes,
} from 'hq/components/views/planner/shifts/filters/utils/utils';
import { PlanningFilters, ShiftPlanningFiltersFormType } from './planning-filter.types';
import { PlanningFilterData } from './filters';

const getShiftPlanningFiltersDefaultValues = (
  appliedFilters: PlanningFilters,
  filterData: PlanningFilterData
): ShiftPlanningFiltersFormType => {
  const result: ShiftPlanningFiltersFormType = {
    branchOffices: null,
    departments: null,
    jobType: null,
    isFreelance: appliedFilters.isFreelance ?? false,
    isTempWork: appliedFilters.isTempWork ?? false,
    isEmployee: appliedFilters.isEmployee ?? false,
    filledStatusCheckboxValue: !!appliedFilters.filledStatus,
    allowApplicantsFilter: appliedFilters.hasApplicants != null ? true : false,
    jobTypeCheckboxValue: !!appliedFilters.jobType?.length,
    filledStatus: appliedFilters.filledStatus ? appliedFilters.filledStatus : 'inProgress',
    hasApplicants: appliedFilters.hasApplicants != null ? appliedFilters.hasApplicants : true,
    businessUnitCheckboxValue: !!appliedFilters.branchOfficeIds?.length,
    employmentTypeCheckboxValue:
      !!appliedFilters.isFreelance || !!appliedFilters.isTempWork || !!appliedFilters.isEmployee,
  };

  if (appliedFilters.jobType?.length) {
    const jobTypes = getJobTypes(appliedFilters.jobType, filterData.jobTypes);
    if (jobTypes?.length) {
      result.jobType = jobTypes.map((jt) => ({ id: jt.value, name: jt.label }));
    }
  }

  if (appliedFilters.branchOfficeIds?.length) {
    result.branchOffices = getBranchOffices(
      appliedFilters.branchOfficeIds,
      filterData.businessUnits.branchOffices
    );
  }

  if (appliedFilters.departmentIds?.length) {
    result.departments = getDepartments(
      appliedFilters.departmentIds,
      filterData.businessUnits.branchOffices
    );
  }

  if (!appliedFilters.branchOfficeIds?.length) {
    return result;
  }
  if (!filterData?.businessUnits) {
    return result;
  }

  const { businessUnits } = filterData;

  if (!businessUnits.branchOffices?.length) {
    return result;
  }

  const branchOfficeFilter = businessUnits.branchOffices.find((bo) =>
    appliedFilters.branchOfficeIds?.includes(bo.branchOfficeId)
  );

  if (!branchOfficeFilter) {
    return result;
  }

  if (!appliedFilters.departmentIds?.length) {
    return result;
  }

  const departmentFilter = branchOfficeFilter.departments.find((dept) =>
    appliedFilters.departmentIds?.includes(dept.departmentId)
  );

  if (!departmentFilter) {
    return result;
  }

  return result;
};

export { getShiftPlanningFiltersDefaultValues };
